// removed by extract-text-webpack-plugin
module.exports = {"footer":"_2tvn","container":"_3uqo","logo":"_1exL","logoContainer":"_1CEr","title":"_2jpY","text":"sxUX","wrapper":"_2vbS","link":"_2ux7","arrow":"_2zoX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/styles.scss
// module id = 425
// module chunks = 0